import { Link as RouterLink } from "react-router-dom";
import {
    AppBar,
    Avatar,
    Button,
    Box,
    Hidden,
    IconButton,
    Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import BusinessIcon from '@mui/icons-material/Business';
import Logo from "src/components/Logo";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import AuthService from "src/_services/AuthService";
import generateCloudinaryLink from 'src/_utils/generateCloudinaryLink';
import { useSelector } from "react-redux";
import AdminNotifications from "./AdminNotifications";
import { ElevationScroll } from "../components";

export default function AdminAppBar({ toggleDrawer, merchant, ...rest }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { logo } = useSelector(state => {
        if (!state.entities.profile.profile) {
            return { logo: null }
        }
        return state.entities.profile.profile
    })
    const logOut = () => {
        AuthService.logout();
        navigate("/auth/admin", { replace: true });
    }
    return (
        <ElevationScroll>
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Hidden lgUp>
                        <IconButton color="inherit" onClick={toggleDrawer} size="large">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <RouterLink to="/">
                        <Logo
                            type="light"
                            style={{
                                marginInlineStart: "4vw" /*128 - 16 - 36 - 10*/,
                            }}
                        />
                    </RouterLink>
                    <Box sx={{ flexGrow: 1 }} />
                    <AdminNotifications />
                    <Button
                        onClick={logOut}
                        disableRipple
                        color="inherit"
                        sx={{ textTransform: "none" }}
                    >
                        {t("Log Out")}
                    </Button>
                    <Avatar
                        component={RouterLink}
                        src={generateCloudinaryLink(logo)}
                        sx={{
                            cursor: "pointer",
                            width: 42,
                            height: 42,
                        }}
                    // to="/merchant/account"
                    >
                        <BusinessIcon />
                    </Avatar>
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    )
}